/**
 * 联系人信息
 * @author Created by jiamei.yao 2017/05/22
 */


'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, Keyboard, ScrollView, Image} from 'react-native';
import Icon from '../../../../components/Icon';
import SimpleCard from '../card/simpleCard';
import PriceCard from '../card/priceCard';
import RankCard from '../card/rankCard';
import PictureCard from '../card/pictureCard';
import styles from './style';
import {jump} from '../../../../common/hysdkUtils/jump';
import {QToast} from "@qnpm/q-components";
import ExposureContainer from '../../../../components/ExposureContainer';
import ReactDom from "react-dom";
import {getQueryParam} from "../../../../models/search/util";


const cardContainerMap = {
    'simple': SimpleCard,
    'price': PriceCard,
    'rank': RankCard,
    'picture': PictureCard,
};


class CardSectionList extends Component {
    constructor(props) {
        super(props);
    }

    jumpUrl(jumpUrl) {
        const appId = getQueryParam('appId');

        if (jumpUrl.indexOf('?') > -1) {
            jumpUrl = `${jumpUrl}&appId=${appId}`;
        } else {
            jumpUrl = `${jumpUrl}?appId=${appId}`;
        }

        if (jumpUrl) {
            jump({
                url: jumpUrl,
                headerType: getQueryParam('type', jumpUrl) || 'navibar-none'
            });
        } else {
            QToast.show('暂时无法跳转，请稍后再试');
        }
    }

    jump(item, rowIndex, colIndex) {
        GodEye.log({
            r: 'bargain_card_item_click',
            ...this.getLogParam(item, rowIndex, colIndex)
        });

        this.jumpUrl(item.scheme);
    }

    getLogParam(flight, rowIndex, colIndex) {
        const {depCity, arrCity, price, flightNo, depDate, arrDate, recommendScore, scoreExpression, travelType} = flight || {};

        let index = 0;
        if (!colIndex) {
            index = rowIndex + 1;
        } else {
            index = 2 * rowIndex + colIndex
        }

        return {
            dep_city: depCity,
            arr_city: arrCity,
            price: price,
            flight_no: flightNo,
            dep_date: depDate,
            arr_date: arrDate,
            score: recommendScore,
            expression: scoreExpression,
            holiday: this.props.data.title,
            theme: this.props.selectedFilter,
            flight_type: travelType,
            index
        }
    }

    onExposureMore(title) {
        GodEye.log({
            r: 'tab_jump_show',
            tab: title,
            cat: getQueryParam('cat') || ''
        });
    }

    onExposure(flight, rowIndex, colIndex) {
        GodEye.log({
            r: 'bargain_card_item_show',
            ...this.getLogParam(flight, rowIndex, colIndex)
        })
    }

    componentDidMount() {
        this.dom = ReactDom.findDOMNode(this);
    }

    componentDidUpdate() {
        // 模拟onLayout
        this.props.onLayout({
            nativeEvent: {
                layout: {
                    y: this.dom.offsetTop
                }
            }
        }, this.props.index)
    }

    render() {
        let {flightInfoList, groupedList, isDoubleColumn, showType, title, itemTopBgPicUrl, tabJumpUrl} = this.props.data || {};
        let renderList = flightInfoList;
        let index = this.props.index;

        if (isDoubleColumn) {
            renderList = groupedList;
        }

        let CardConatiner = cardContainerMap[showType];

        return (
            <View style={styles.cheapSectionWrapper} onLayout={(e) => {
                this.props.onLayout(e, index)
            }} key={index}>
                {this.props.index !== 0 ? <Image style={styles.cheapImage} source={{uri: itemTopBgPicUrl}}
                                                 resizeMode={'contain'}/> : null}
                <View style={[styles.cheapSection, this.props.index === 0 ? {marginTop: 0} : {}]}>
                    {
                        renderList.map((item, rowIndex) => {
                            if (isDoubleColumn) {
                                return <View style={styles.priceCardBlock} key={rowIndex}>
                                    {
                                        item ? item.map((flight, colIndex) => {
                                            if (title === '国内热门' && rowIndex < 1) {
                                                return (
                                                    <ExposureContainer
                                                        key={colIndex}
                                                        type={1}
                                                        style={{flex: 1, marginBottom: 4}}
                                                        percent={0.5}
                                                        firstExposure={true}
                                                        onExposure={() => {
                                                            this.onExposure(flight, rowIndex, colIndex + 1)
                                                        }}
                                                    >
                                                        <PictureCard
                                                            data={flight}
                                                            index={colIndex}
                                                            jump={() => {
                                                                this.jump(flight, rowIndex, colIndex + 1)
                                                            }}
                                                        />
                                                    </ExposureContainer>
                                                )
                                            }
                                            return (
                                                <ExposureContainer
                                                    type={1}
                                                    style={{flex: 1}}
                                                    percent={0.5}
                                                    key={colIndex}
                                                    firstExposure={true}
                                                    onExposure={() => {
                                                        this.onExposure(flight, rowIndex, colIndex + 1)
                                                    }}
                                                >
                                                    <CardConatiner
                                                        data={flight}
                                                        index={colIndex}
                                                        jump={() => {
                                                            this.jump(flight, rowIndex, colIndex + 1)
                                                        }}
                                                    />
                                                </ExposureContainer>
                                            )
                                        }) : null
                                    }
                                </View>
                            }
                            return <ExposureContainer
                                type={1}
                                style={{flex: 1}}
                                percent={0.5}
                                firstExposure={true}
                                key={rowIndex}
                                onExposure={() => {
                                    this.onExposure(item, rowIndex, 0)
                                }}
                            >
                                <CardConatiner data={item} jump={() => {
                                    this.jump(item, rowIndex, 0)
                                }}/>
                            </ExposureContainer>
                        })
                    }

                    {
                        tabJumpUrl
                            ? <ExposureContainer
                                type={1}
                                style={{flex: 1}}
                                percent={0.5}
                                onExposure={() => {
                                    this.onExposureMore(title)
                                }}
                            >
                                <TouchableOpacity style={styles.moreField} onPress={() => {
                                    GodEye.log({
                                        r: 'tab_jump_url',
                                        tab: title,
                                        cat: `${getQueryParam('cat') || ''}_${title}`
                                    });
                                    this.jumpUrl(tabJumpUrl)
                                }}>
                                    <Text style={styles.moreText}>全部{title}榜单</Text>
                                    <Icon name='rightArrow' color='#999999' size={12} style={styles.moreIcon}/>
                                </TouchableOpacity>
                            </ExposureContainer>
                            : null
                    }

                </View>
            </View>
        )
    }
}

export default CardSectionList;
